/**
 * Find the list of duplicate file names in an array of files
 * @param fileList List of files
 * @returns list of duplicate file names
 */
function findDuplicateFileNames(fileList: File[]) {
  const fileNames = fileList.map((file) => file.name);
  const uniqueFileNames = new Set();
  const duplicateFileNames = new Set();

  for (const fileName of fileNames) {
    if (uniqueFileNames.has(fileName)) {
      duplicateFileNames.add(fileName);
    } else {
      uniqueFileNames.add(fileName);
    }
  }

  return Array.from(duplicateFileNames);
}

export default findDuplicateFileNames;
